module.exports = __webpack_public_path__ + "static/media/classics.22819746.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/classics.jpg
// module id = 333
// module chunks = 37